module.exports = __webpack_public_path__ + "static/media/amex.163808f8.svg";